// Sets CSS variable --document-width to the current document width
// Use instead of 100vw to avoid horizontal scrollbars
HB.onReady(() => {
  const setDocumentWidth = () => {
    let documentWidth = document.documentElement.clientWidth
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty(
        "--document-width",
        documentWidth + "px",
      )
    })
  }

  const throttledSetDocumentWidth = HB.throttle(setDocumentWidth, 100)

  setDocumentWidth()
  window.addEventListener("resize", throttledSetDocumentWidth)
})
